import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { useReducedExperience } from '../../lib/performance';
export function AnimatedBackground() {
  const reducedExperience = useReducedExperience();
  const particles = useMemo(() => Array.from({
    length: 8
  }).map((_, index) => ({
    id: index,
    left: 8 + index * 13 % 82,
    top: 10 + index * 19 % 76,
    size: 3 + index % 3 * 2,
    duration: 15 + index * 2,
    delay: index * 0.45,
    drift: 18 + index % 4 * 6
  })), []);
  return <div aria-hidden className={`ambient-background fixed inset-0 -z-10 overflow-hidden bg-white ${reducedExperience ? 'is-static' : ''}`} data-id="element-83" data-mp="36m0ieiaz5j6n">
      <div className="ambient-orb absolute -left-[20%] -top-[20%] h-[58vh] w-[58vh] rounded-full bg-[radial-gradient(circle,rgba(45,168,255,0.16),transparent_65%)] blur-3xl animate-gradient-shift" data-id="element-84" data-mp="31tpk1jvvu5g7" />
      <div className="ambient-orb absolute right-[-16%] top-[12%] h-[52vh] w-[52vh] rounded-full bg-[radial-gradient(circle,rgba(0,87,255,0.1),transparent_65%)] blur-3xl animate-gradient-shift [animation-delay:-6s]" data-id="element-85" data-mp="2963ei633gqqp" />
      <div className="ambient-orb absolute bottom-[-20%] left-[25%] h-[58vh] w-[58vh] rounded-full bg-[radial-gradient(circle,rgba(234,245,255,0.82),transparent_60%)] blur-3xl animate-gradient-shift [animation-delay:-11s]" data-id="element-86" data-mp="9ucfq56klyyb" />

      {!reducedExperience && <>
          <motion.div className="absolute top-[8%] h-28 w-[42%] rounded-full bg-white/50 blur-3xl" animate={{
        x: ['-25%', '150%']
      }} transition={{
        duration: 75,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-87" data-mp="3i579gezn0yns" />
          {particles.map(particle => <motion.span key={particle.id} className="absolute rounded-full" style={{
        left: `${particle.left}%`,
        top: `${particle.top}%`,
        width: particle.size,
        height: particle.size,
        background: 'rgba(45,168,255,0.55)'
      }} animate={{
        y: [0, -particle.drift, 0],
        opacity: [0.1, 0.48, 0.1]
      }} transition={{
        duration: particle.duration,
        delay: particle.delay,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-88" data-mp="16ev0kknunjb2" />)}
        </>}
    </div>;
}